;(function($){
	$.fn.datepicker.dates['es'] = {
		days: ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"],
		daysShort: ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"],
		daysMin: ["Do", "Lu", "Ma", "Mi", "Ju", "Vi", "Sa"],
		months: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
		monthsShort: ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"],
		today: "Hoy",
		monthsTitle: "Meses",
		clear: "Borrar",
		weekStart: 1,
		format: "dd/mm/yyyy"
	};
}(jQuery));

document.addEventListener("turbolinks:load", ()=>{
  $(".select2").select2();
	
	$(".datepicker-full").each((k,v) => {
		$(v).datepicker({    
			format: 'yyyy/mm/dd',
			autoclose: true,
			clearBtn: true,
			language: $("html").attr("lang"),
			startDate: $(v).data('start-date') || ""
		});
	});
	
	$('body').bind("cocoon:after-insert", (e, inserted_item) => {
		$(inserted_item).find(".select2").select2();
	});

	$("#current-language").change(e => {
		fetch('/change_language', {
			method: "POST",
      headers: new Headers({
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.getElementsByName('csrf-token')[0].attributes['content'].value
      }),
      body: JSON.stringify({ language_code: e.currentTarget.value })
		})
		.then(response => { 
      return response.json(); 
    })
    .catch(error => {
      swal('Could not change language');
    })
    .then(data => {
      location.reload();
    });
	});
});